<router-outlet></router-outlet>

<ng-container *ngIf="visible$ | async">
  <div *ngIf="autoScrollerService.activated"
       class="top-overlay auto-mode-container"
       [ngClass]="{'hide': !showUi}">
    <span class="uppercase">Auto</span> ({{ autoScrollerService.multiplier }}x)
  </div>

  <div class="top-overlay action-icon-container"
       [ngClass]="{'hide': !showUi}">
    <label class="no-margin">
      <fa-icon class="action-icon" data-tooltip="Import file"
               [ngClass]="{'tooltip bottom-center': uiSettingsService.showTooltips$ | async}"
               [icon]="faFileMedical"></fa-icon>
      <input type="file" accept=".htmlz,.epub" multiple (change)="onInputChange(inputRef)" hidden #inputRef>
    </label>
    <label class="no-margin" *ngIf="!isMobileDevice">
      <fa-icon class="action-icon margin-icon" data-tooltip="Import folder"
               [ngClass]="{'tooltip bottom-center': uiSettingsService.showTooltips$ | async}"
               [icon]="faFolderPlus"></fa-icon>
      <input type="file" webkitdirectory directory multiple (change)="onInputChange(inputDirRef)"
        hidden #inputDirRef>
    </label>
    <fa-icon class="action-icon margin-icon" data-tooltip="Bookmark"
             [ngClass]="{'tooltip bottom-center': uiSettingsService.showTooltips$ | async}"
             [icon]="faBookmark"
             (click)="bookmarManagerService.saveScrollPosition()"></fa-icon>
    <fa-icon class="action-icon margin-icon" data-tooltip="Settings"
             [ngClass]="{'tooltip bottom-right': uiSettingsService.showTooltips$ | async}"
             [icon]="faCog"
             (click)="setShowSettingsDialog(true)"></fa-icon>
  </div>
  <div class="top-overlay action-icon-container--left"
       [ngClass]="{'hide': !showUi}">
    <fa-icon class="action-icon margin-icon" data-tooltip="Toggle Fullscreen"
             [ngClass]="{'tooltip bottom-left': uiSettingsService.showTooltips$ | async}"
             *ngIf="!(minimalUi$ | async) && supportsFullscreen && !autoScrollerService.activated"
             [icon]="faExpand"
             (click)="toggleFullscreen()"></fa-icon>
  </div>
</ng-container>

<div class="overlay-container loading-container"
     *ngIf="loadingDb || (ebookDisplayManagerService.loadingFile$ | async); else notLoadingRef">
  Loading...
</div>

<div class="overlay-container loading-container drop-zone-container darker"
     *ngIf="(ebookDisplayManagerService.loadingFiles$ | async)">
  <div class="progress-container">
    <div class="truncate">{{ebookDisplayManagerService.loadingFiles$.value?.title}}</div>
    <div class="progress">
      <span [style.width]="ebookDisplayManagerService.loadingFiles$.value?.progress"></span>
    </div>
  </div>
</div>

<ng-template #notLoadingRef>
  <label class="overlay-container drop-zone-container label-button" *ngIf="!(visible$ | async)" (click)="zoneInputRef.click();"
    (contextmenu)="$event.preventDefault();zoneInputDirRef.click();">
    {{dropZoneLabel}}
  </label>
  <input type="file" accept=".htmlz,.epub" multiple hidden #zoneInputRef (change)="onInputChange(zoneInputRef)">
  <input type="file" webkitdirectory directory multiple hidden #zoneInputDirRef (change)="onInputChange(zoneInputDirRef)">
</ng-template>

<div class="dialog-overlay"
     *ngIf="showSettingsDialog"
     (click)="setShowSettingsDialog(false)">
  <app-settings-dialog class="settings-dialog"
                       (closeClick)="setShowSettingsDialog(false)"
                       (click)="$event.stopPropagation()"></app-settings-dialog>
</div>

<fa-icon *ngIf="isUpdateAvailable"
         [icon]="faSyncAlt"
         class="information-overlay bottom-overlay update-ready-icon"></fa-icon>

<div id="scroll-info"
     class="information-overlay bottom-overlay scroll-information"
     [ngClass]="{'invisible': !showUi}"
     (click)="toggleUi()">
  Loading position...
</div>
